import { createContext } from 'react';

const HcpDashboardContext = createContext();
export default HcpDashboardContext;
